<template>
  <div class="my-container" :class="{ mobile: isMobile, desktop: isDesktop }">
    <v-app>
      <div class="settings">
        <div class="head-slider">
          <v-toolbar>
            <v-tabs v-model="my_tab" align-with-title>
              <v-tabs-slider color="#eb307b"></v-tabs-slider>
              <v-tab v-for="tab_item in tab_items" :key="tab_item">
                {{ tab_item }}
              </v-tab>
            </v-tabs>
          </v-toolbar>
        </div>
        <v-tabs-items v-model="my_tab">
          <v-tab-item class="px-4">
            <div class="setting-container">
              <div class="py-5">
                <div
                  class="big-upload mt-1 pb-4 px-2 text-center"
                  v-if="mainImage == '' || mainImage == null"
                >
                  <div class="upload-locker text-center">
                    <img
                      src="/assets/site/images/seller-icons/upload.svg"
                      alt="image"
                    />
                  </div>
                  <p class="my-text">
                    برای گذاشتن عکس فروشگاه بر روی دکمه ی بارگذاری کلیک کنید.
                  </p>
                  <p class="my-text mini">
                    ( حداقل اندازه تصویر 1600 در 1400 و حداقل سایز 10mb )
                  </p>
                  <div
                    :class="{ 'has-image logo': theImage.logo }"
                    @click="$refs.logo.click()"
                    class="image-button logo ml-2"
                  >
                    <div class="mb-1">بارگذاری لوگو</div>
                    <div class="img-wrapper">
                      <img
                        v-if="my_logo_chosen_url != null"
                        :src="my_logo_chosen_url"
                        alt="image"
                      />
                      <img
                        v-if="my_logo_chosen_url == null && theImage.logo"
                        :src="theImage.logo"
                        alt="image"
                      />
                    </div>
                  </div>
                  <input
                    type="file"
                    accept="image"
                    ref="logo"
                    style="display: none"
                    @change="up_image(1)"
                  />
                  <div
                    :class="{ 'has-image': theImage.banner }"
                    @click="$refs.banner.click()"
                    class="image-button banner"
                  >
                    <div class="mb-1">بارگذاری بنر</div>
                    <div class="img-wrapper">
                      <img
                        v-if="my_banner_chosen_url"
                        :src="my_banner_chosen_url"
                        alt="image"
                      />
                      <img
                        v-if="!my_banner_chosen_url && theImage.banner"
                        :src="theImage.banner"
                        alt="image"
                      />
                    </div>
                  </div>
                  <input
                    type="file"
                    accept="image"
                    ref="banner"
                    style="display: none"
                    @change="up_image(2)"
                  />
                </div>
              </div>
              <div class="text-center pb-4 border-bottom mb-2">
                <button
                  class="my-button w-75"
                  outlined
                  @click="submit_public()"
                >
                  ذخیره
                </button>
              </div>
              <div class="general-settings pb-3">
                <p class="my-title-3 mb-3">اطلاعات فروشگاه</p>
                <v-row>
                  <v-col>
                    <v-text-field
                      color="#fc3e9a"
                      label="نام فروشگاه"
                      v-model="base_data.name"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="hasAddress">
                  <v-col>
                    <v-text-field
                      :disabled="true"
                      v-model="shop_address"
                      color="#fc3e9a"
                      label="آدرس"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <div class="map-container">
                  <p class="my-title-3">پین کردن آدرس:</p>
                  <div id="addressMap">
                    <l-map
                      ref="map"
                      v-if="mapOptions.showMap"
                      :zoom="mapOptions.zoom"
                      :center="mapOptions.center"
                      :options="mapOptions.mapOptions"
                      style="height: 100%; width: 100%"
                      @update:center="updateCenter"
                      @update:zoom="zoomUpdate"
                    >
                      <l-tile-layer :url="mapOptions.url" />
                      <l-marker
                        v-if="hasAddress || choose_location"
                        :lat-lng="[address_data.lat, address_data.long]"
                      >
                        <l-icon
                          :icon-size="[40, 40]"
                          icon-url="/assets/site/images/seller-icons/target-pin.svg"
                        />
                      </l-marker>
                    </l-map>
                    <icon-image
                      v-if="!hasAddress"
                      address="/assets/site/images/seller-icons/loc.svg"
                      classes="map-marker huge"
                    ></icon-image>
                    <button
                      v-if="!hasAddress"
                      class="map-control"
                      ref="bt"
                      @click="change"
                    >
                      انتخاب موقعیت*
                    </button>
                  </div>
                  <div v-if="choose_location" class="my-alarm mini mt-2">
                    * بعد از انتخاب دقیق لوکیشن، کلیک روی "ثبت آدرس" الزامی است.
                  </div>
                </div>
                <div class="full-width">
                  <div v-if="!hasAddress" class="mt-4">
                    <p class="text-color">انتخاب محل</p>
                    <!-- <v-select
                      v-model="district_id"
                      placeholder="محله"
                      :items="districts"
                      item-text="text"
                      item-value="id"
                      label="انتخاب محله"
                      solo
                    ></v-select> -->
                    <v-autocomplete
                      v-model="district_id"
                      placeholder="محله"
                      :items="districts"
                      item-text="text"
                      item-value="id"
                      label="انتخاب محله"
                      solo
                    ></v-autocomplete>
                  </div>
                  <div>
                    <v-text-field
                      v-if="!hasAddress"
                      placeholder="متن آدرس*"
                      color="#fc3e9a"
                      :disabled="false"
                      v-model="my_address"
                      solo
                    ></v-text-field>
                    <p class="my-alarm mini">{{ address_error }}</p>
                  </div>
                  <div class="text-center">
                    <button
                      v-if="!hasAddress"
                      class="my-button-2"
                      @click="submit_address()"
                    >
                      ثبت آدرس
                    </button>
                  </div>
                </div>
                <v-divider></v-divider>
                <h5 class="text-color">محله ها</h5>
                <v-row class="mb-3">
                  <v-col cols="6">
                    <v-combobox
                      solo
                      filled
                      v-model="select_district"
                      :items="districts"
                      label="افزودن محله"
                    ></v-combobox>
                  </v-col>
                  <v-col cols="6" class="pt-1">
                    <button @click="addExtraDistrict" class="my-button-2 py-2">
                      افزوده شود
                    </button>
                  </v-col>
                  <v-col cols="12">
                    <p class="my-title-3 ml-2">محله های اضافه شده:</p>
                    <div>
                      <div
                        class="
                          my-text
                          tag-location
                          my-1
                          mx-1
                          d-inline-block
                          py-1
                          px-1
                          rounded
                        "
                        v-for="(item, i) in shopDistricts"
                        :key="i"
                      >
                        <div class="d-inline-block">
                          {{ item.name }}
                        </div>
                        <div
                          class="px-1 py-1 d-inline-block pointer"
                          @click="close_district(item, i)"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16.857"
                            height="17.857"
                            viewBox="0 0 16.857 17.857"
                          >
                            <g
                              id="Group_1416"
                              data-name="Group 1416"
                              transform="translate(-744.017 -87.017)"
                              opacity="0.86"
                            >
                              <g
                                id="Group_1314"
                                data-name="Group 1314"
                                transform="translate(746.136 89.136)"
                              >
                                <line
                                  id="Line_263"
                                  data-name="Line 263"
                                  x1="12.618"
                                  y2="13.618"
                                  fill="none"
                                  stroke="#585454"
                                  stroke-linecap="round"
                                  stroke-width="3"
                                />
                                <line
                                  id="Line_264"
                                  data-name="Line 264"
                                  x1="13.618"
                                  y2="12.618"
                                  transform="translate(12.618 0) rotate(90)"
                                  fill="none"
                                  stroke="#585454"
                                  stroke-linecap="round"
                                  stroke-width="3"
                                />
                              </g>
                            </g>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item class="px-4">
            <div class="bank-form pt-4">
              <p class="mb-3">نام بانک</p>
              <v-select
                v-model="accounts.bank_id"
                :items="bankNames"
                item-text="desc"
                item-value="id"
                label="انتخاب کنید"
                solo
              ></v-select>
              <p>شماره کارت</p>
              <v-text-field
                color="#fc3e9a"
                :disabled="false"
                v-model="accounts.card"
                solo
              ></v-text-field>
              <p>شماره حساب</p>
              <v-text-field
                color="#fc3e9a"
                :disabled="false"
                v-model="accounts.account"
                solo
              ></v-text-field>
              <p>شماره شبا</p>
              <v-text-field
                color="#fc3e9a"
                :disabled="false"
                v-model="accounts.sheba"
                solo
              ></v-text-field>
              <p class="my-text">
                گلپینو برای تسویه حساب به اطلاعات بانکی شما نیاز دارد.
              </p>
              <button class="my-button w-100" @click="submitFinancials">
                ثبت اطلاعات حساب
              </button>
            </div>
          </v-tab-item>
          <v-tab-item class="px-4">
            <div>
              <div class="setting-container pt-2 pb-3">
                <div class="py-3">
                  <p>زمان آماده سازی (دقیقه)</p>
                  <v-text-field
                    color="#fc3e9a"
                    :disabled="false"
                    v-model="ready_time"
                    solo
                  ></v-text-field>
                  <p>محدوده خدمت رسانی (متر)</p>
                  <v-select
                    v-model="my_service_range"
                    :items="serviceRanges"
                    item-text="value"
                    item-value="id"
                    :label="my_service_range"
                    solo
                  ></v-select>
                </div>
                <div class="clearfix mb-4 line py-2">
                  <div class="right half">
                    <div class="text-center">مسافت</div>
                  </div>
                  <div class="right half">
                    <div class="text-center">هزینه (تومان)</div>
                  </div>
                </div>
                <p class="my-text mini">
                  * فیلد خالی، به منزله ی مبلغ صفر می باشد
                </p>
                <div>
                  <div class="right half clearfix">
                    <div
                      v-for="(distance, index) in distances"
                      :key="index"
                      class="py-4 text-center distance-text"
                    >
                      <div class="text-center">{{ distance.text }} متر</div>
                    </div>
                  </div>
                  <div class="right half">
                    <div v-for="(cost, index) in sendCosts" :key="index">
                      <v-text-field
                        color="#fc3e9a"
                        :disabled="false"
                        v-model="cost.cost"
                        solo
                      ></v-text-field>
                    </div>
                  </div>
                </div>

                <button class="my-button w-100 mb-3" @click="submit_sending()">
                  ثبت
                </button>
                <p
                  class="my-alarm d-none mb-2"
                  :class="{ 'd-block': active_alarm }"
                >
                  * لطفا محدوده خدمت رسانی را انتخاب کنید
                </p>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item class="px-4">
            <div class="setting-container">
              <div class="clearfix py-4 line bottom mb-6">
                <div class="right small text-center">روز</div>
                <div class="right small text-center">آغاز فعالیت</div>
                <div class="right small text-center">پایان فعالیت</div>
              </div>
              <div v-if="workTimes">
                <div class="clearfix">
                  <div class="right small text-center clearfix pt-3">
                    <div class="text-center">شنبه</div>
                  </div>
                  <div class="right small px-1">
                    <v-text-field
                      color="#fc3e9a"
                      :disabled="false"
                      placeholder="مثل: 01:08"
                      v-model="workTimes[0].open_at"
                      solo
                    ></v-text-field>
                  </div>
                  <div class="right small px-1">
                    <v-text-field
                      placeholder="مثل: 01:08"
                      color="#fc3e9a"
                      :disabled="false"
                      v-model="workTimes[0].close_at"
                      solo
                    ></v-text-field>
                  </div>
                </div>
                <div class="clearfix">
                  <div class="right small text-center clearfix pt-3">
                    <div class="text-center">یکشنبه</div>
                  </div>
                  <div class="right small px-1">
                    <v-text-field
                      color="#fc3e9a"
                      placeholder="مثل: 01:08"
                      :disabled="false"
                      v-model="workTimes[1].open_at"
                      solo
                    ></v-text-field>
                  </div>
                  <div class="right small px-1">
                    <v-text-field
                      placeholder="مثل: 01:08"
                      color="#fc3e9a"
                      :disabled="false"
                      v-model="workTimes[1].close_at"
                      solo
                    ></v-text-field>
                  </div>
                </div>
                <div class="clearfix">
                  <div class="right small text-center clearfix pt-3">
                    <div class="text-center">دوشنبه</div>
                  </div>
                  <div class="right small px-1">
                    <v-text-field
                      placeholder="مثل: 01:08"
                      color="#fc3e9a"
                      :disabled="false"
                      v-model="workTimes[2].open_at"
                      solo
                    ></v-text-field>
                  </div>
                  <div class="right small px-1">
                    <v-text-field
                      placeholder="مثل: 01:08"
                      color="#fc3e9a"
                      :disabled="false"
                      v-model="workTimes[2].close_at"
                      solo
                    ></v-text-field>
                  </div>
                </div>
                <div class="clearfix">
                  <div class="right small text-center clearfix pt-3">
                    <div class="text-center">سه شنبه</div>
                  </div>
                  <div class="right small px-1">
                    <v-text-field
                      placeholder="مثل: 01:08"
                      color="#fc3e9a"
                      :disabled="false"
                      v-model="workTimes[3].open_at"
                      solo
                    ></v-text-field>
                  </div>
                  <div class="right small px-1">
                    <v-text-field
                      placeholder="مثل: 01:08"
                      color="#fc3e9a"
                      :disabled="false"
                      v-model="workTimes[3].close_at"
                      solo
                    ></v-text-field>
                  </div>
                </div>
                <div class="clearfix">
                  <div class="right small text-center clearfix pt-3">
                    <div class="text-center">چهارشنبه</div>
                  </div>
                  <div class="right small px-1">
                    <v-text-field
                      placeholder="مثل: 01:08"
                      color="#fc3e9a"
                      :disabled="false"
                      v-model="workTimes[4].open_at"
                      solo
                    ></v-text-field>
                  </div>
                  <div class="right small px-1">
                    <v-text-field
                      placeholder="مثل: 01:08"
                      color="#fc3e9a"
                      :disabled="false"
                      v-model="workTimes[4].close_at"
                      solo
                    ></v-text-field>
                  </div>
                </div>
                <div class="clearfix">
                  <div class="right small text-center clearfix pt-3">
                    <div class="text-center">پنجشنبه</div>
                  </div>
                  <div class="right small px-1">
                    <v-text-field
                      placeholder="مثل: 01:08"
                      color="#fc3e9a"
                      :disabled="false"
                      v-model="workTimes[5].open_at"
                      solo
                    ></v-text-field>
                  </div>
                  <div class="right small px-1">
                    <v-text-field
                      placeholder="مثل: 01:08"
                      color="#fc3e9a"
                      :disabled="false"
                      v-model="workTimes[5].close_at"
                      solo
                    ></v-text-field>
                  </div>
                </div>
                <div class="clearfix">
                  <div class="right small text-center clearfix pt-3">
                    <div class="text-center">جمعه</div>
                  </div>
                  <div class="right small px-1">
                    <v-text-field
                      placeholder="مثل: 01:08"
                      color="#fc3e9a"
                      :disabled="false"
                      v-model="workTimes[6].open_at"
                      solo
                    ></v-text-field>
                  </div>
                  <div class="right small px-1">
                    <v-text-field
                      placeholder="مثل: 01:08"
                      color="#fc3e9a"
                      :disabled="false"
                      v-model="workTimes[6].close_at"
                      solo
                    ></v-text-field>
                  </div>
                </div>
                <div class="text-center py-3">
                  <button
                    class="my-button w-100"
                    outlined
                    @click="submitWorkDaysAndHours"
                  >
                    ذخیره
                  </button>
                </div>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-app>
  </div>
</template>
<script>
import {
  ref,
  onMounted,
  computed,
  inject,
  watch,
  reactive,
} from "@vue/composition-api";
import RoundedImage from "../../Common/roundImage";
import ImageIcon from "../../Common/icon";
import CustomField from "./partials/SettingsField";
import CustomInput from "../../Common/CustomInput";
import MenuItem from "./partials/RightMenuItem";
import Service from "../../../utils/seller-service";
import AddressModal from "../../Common/AddressModal";
import $ from "jquery";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LIcon, LControl } from "vue2-leaflet";
import IconImage from "../../Common/icon";

export default {
  components: {
    RoundedImage,
    ImageIcon,
    CustomField,
    MenuItem,
    AddressModal,
    IconImage,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    CustomInput,
  },
  setup() {
    onMounted(() => {
      getServiceRanges();
      getBanks();
      getFinancials();
      getSellerInfos().then((baseInfoLoaded.value = true));
    });
    const my_service_range = ref(null);
    const active_alarm = ref(false);
    const authService = computed(() => {
      return Service(true);
    });

    const getServiceRanges = () => {
      authService.value.receive(
        "seller/base/servicerange",
        {},
        (s, d) => {
          if (s == 200) {
            if (d.data != [] && d.data != null) {
              serviceRanges.value = d.data;
              console.log(serviceRanges.value);
            }
          }
        },
        (s, e) => {}
      );
      authService.value.receive(
        "seller/base/sellerservicerange",
        {},
        (s, d) => {
          if (s == 200) {
            my_service_range.value = d.data.service_value;
          }
        },
        (s, e) => {}
      );
    };

    const editBankAccount = ref(false);
    const bankToEdit = ref({ value: null, valid: true });

    const global = inject("global");
    const basicModels = ref({
      fields: [
        {
          name: "نام و نام خانوادگی",
          value: { value: null, valid: true },
          deactive: true,
        },
        {
          name: "نام کاربری",
          value: { value: null, valid: true },
          deactive: true,
        },
        {
          name: "نام کاربری",
          value: { value: null, valid: true },
          deactive: true,
        },
        {
          name: "شماره ثابت",
          value: { value: null, valid: true },
          deactive: true,
        },
        {
          name: "شماره موبایل",
          value: { value: null, valid: true },
          deactive: true,
        },
        {
          name: "تاریخ تولد",
          value: { value: null, valid: true },
          deactive: true,
        },
        {
          name: "جنسیت",
          value: { value: null, valid: true },
          deactive: true,
        },
      ],
    });
    const secondaryModels = ref({
      fields: [
        {
          addressModal: true,
          name: "آدرس فروشگاه",
          value: { value: null, valid: true },
          deactive: true,
        },
        {
          name: "آپلود جواز کسب",
          value: { value: null, valid: true },
          deactive: true,
        },
        {
          name: "ساعات کاری",
          value: { value: null, valid: true },
          deactive: true,
        },
        {
          name: "محدوده ی ارسال",
          value: { value: null, valid: true },
          deactive: true,
        },
        {
          name: "روش ارسال",
          value: { value: null, valid: true },
          deactive: true,
        },
      ],
    });
    const menuItems = ref([
      { text: "اطلاعات شخصی", icon: "user.svg", active: true },
      {
        text: "اعلان ها",
        icon: "black-bell.svg",
        active: false,
      },
      { text: "فعالیت حساب", icon: "activity.svg", active: false },
      {
        text: "تنظیمات امنیتی",
        icon: "lock.svg",
        active: false,
      },
      { text: "تغییر رمز عبور", icon: "shield.svg", active: false },
      {
        text: "اطلاعات حساب",
        icon: "dollar.svg",
        active: false,
      },
    ]);
    const notifModels = ref([
      {
        label: "هر وقت با فعالیت غیر معمول روبرو شدید به من اطلاع دهید",
        value: { value: false, valid: true },
        name: "unusual-activity",
      },
      {
        label: "هر وقت شخص دیگری با مشخصات من وارد شد اطلاع دهید",
        value: { value: false, valid: true },
        name: "break-in",
      },
    ]);
    const newsModels = ref([
      {
        label: "درباره ی فروش و خبر های جدید از طریق ایمیل اطلاع دهید",
        value: { value: false, valid: true },
        name: "news",
      },
      {
        label: "درباره ی بروز رسانی های جدید به من اطلاع دهید",
        value: { value: false, valid: true },
        name: "update",
      },
      {
        label: "درباره ی نکات استفاده از حساب به من ایمیل بزنید",
        value: { value: false, valid: true },
        name: "guide",
      },
    ]);
    const aBankAccount = ref({});
    const workTime = ref({
      edit: false,
      deactive: true,
      fields: [
        { name: "از ساعت", value: { value: null, valid: true } },
        {
          name: "تا ساعت",
          value: { value: null, valid: true },
        },
      ],
    });
    const preparationTime = ref(null);
    const ready_time = ref(null);
    const sendCost = reactive({
      deactive: true,
      edit: false,
      fields: [
        { value: { value: null, valid: true }, name: "مسافت" },
        { value: { value: null, valid: true }, name: "هزینه" },
      ],
    });
    const serviceRange = ref({
      deactive: true,
      edit: false,
      fields: [{ value: { value: null, valid: true } }],
    });
    const shopAddress = ref({
      deactive: true,
      edit: false,
      fields: [{ value: { value: null, valid: true } }],
    });
    const descs = ref({
      deactive: true,
      edit: false,
      fields: [
        {
          name: "اطلاعات فروشگاه",
          value: { value: global.user.value.name, valid: true },
        },
        {
          name: "توضیحات فروشگاه",
          value: {
            value:
              global.user.value.seller.desc == ""
                ? null
                : global.user.value.seller.desc,
            valid: true,
          },
        },
      ],
    });
    const logoImage = ref({
      deactive: true,
      logo: null,
      banner: null,
      licence: null,
    });
    const theImage = ref({ logo: null, banner: null });
    const fData = ref(new FormData());
    const bankNames = ref(null);
    const sellerSendCosts = ref(null);
    const currentForm = ref(null);
    const hasAddress = ref(false);
    const days = [
      { id: 1, text: "شنبه", value: 1 },
      { id: 2, text: "یک شنبه", value: 2 },
      { id: 3, text: "دو شنبه", value: 3 },
      { id: 4, text: "سه شنبه", value: 4 },
      { id: 5, text: "چهار شنبه", value: 5 },
      { id: 6, text: "پنجشنبه", value: 6 },
      { id: 7, text: "جمعه", value: 7 },
    ];
    const sellerWorkTime = ref(null);
    const districts = ref(null);
    const workTimes = ref([
      { open_at: 0, close_at: 0 },
      { open_at: 0, close_at: 0 },
      { open_at: 0, close_at: 0 },
      { open_at: 0, close_at: 0 },
      { open_at: 0, close_at: 0 },
      { open_at: 0, close_at: 0 },
      { open_at: 0, close_at: 0 },
    ]);
    const workTimesIds = ref({
      value: [],
      valid: true,
    });
    const sendCosts = ref({});
    const sellerServiceDistricts = ref(null);
    const baseInfoLoaded = ref(false);

    watch(
      () => sendCost.fields[0].value.value,
      (n, o) => {}
    );
    const shop_address = ref(null);
    const distance_costs = ref(null);
    const base_data = ref({});
    const address_data = ref({});
    const get_distances = async function () {
      authService.value.receive(
        "seller/base/distance",
        {},
        (s, d) => {
          if (s == 200) {
            distances.value = d.data;
            console.log("distances.value");
            console.log(distances.value);

            distances.value.map((dist) => {
              dist.text = " از " + dist.from + " تا " + dist.to;
              dist.value = dist.id;
            });
          }
        },
        (s, e) => {}
      );
      return distances.value;
    };
    const getSellerInfos = async () => {
      authService.value.receive(
        "seller/address",
        {},
        (s, d) => {
          if (s == 200) {
            shop_address.value = d.data.address;
            hasAddress.value = true;
            address_data.value = d.data;
          }
        },
        (s, e) => {}
      );

      setTimeout(function () {
        if (!hasAddress) {
          global.alertToggle(" ابتدا آدرس را وارد کنید");
        }
      }, 5000);
      get_distances();

      authService.value.receive(
        "seller/base/sendcost",
        {},
        (s, d) => {
          if (s == 200) {
            sendCosts.value = d.data;
          }
        },
        (s, e) => {}
      );
      authService.value.receive(
        "seller/base",
        {},
        (s, d) => {
          if (s == 200) {
            base_data.value = d.data;
            descs.value.fields[0].value.value = d.data.name;
            if (d.data.specification != null && d.data.desc != null) {
              descs.value.fields[1].value.value = d.data.specification;
            }
          }
        },
        (s, e) => {}
      );
      authService.value.receive(
        "seller/base/image",
        {},
        (s, d) => {
          if (s == 200) {
            theImage.value = {
              logo: d.data.logo,
              banner: d.data.banner,
              licence: d.data.licence,
            };
          }
        },
        (s, e) => {}
      );
      //WORKTIME

      var wId = [];
      authService.value.receive(
        "seller/base/worktime",
        {},
        (s, d) => {
          if (s == 200) {
            workTimes.value = d.data;
          }
        },
        (s, e) => {}
      );

      // PREPARATION TIME
      authService.value.receive(
        "seller/base/prepare",
        {},
        (s, d) => {
          if (s == 200) {
            if (d.data != [] && d.data != null) {
              preparationTime.value = d.data;
              ready_time.value = d.data.time;
            }
          }
        },
        (s, e) => {}
      );
      // DISTANCES
    };

    const distances = ref(null);
    const serviceRanges = ref([]);
    const accounts = ref({
      bank_id: "",
      account: "",
      sheba: "",
      card: "",
    });

    const getBanks = () => {
      authService.value.receive(
        "seller/base/banklist",
        {},
        (s, d) => {
          if (s == 200) {
            bankNames.value = d.data;
          }
        },
        (s, e) => {}
      );
    };
    const successfulOp = (s, d) => {
      if (s == 200) {
        fData.value = new FormData();
        global.alertToggle("اطلاعات با موفقیت افزوده شد!");
      }
    };

    const submitValue = (v, i) => {
      let f = new FormData();
      switch (v) {
        case "بانک":
          // activateModel(i);
          authService.value.transmit("");
          break;
        case "workTime":
          currentForm.value = "worktime";
          // activateModel('workTime')
          workTime.value.fields[0].value.valid = true;
          workTime.value.fields[1].value.valid = true;
          workTime.value.fields[0].value.message = "";
          workTime.value.fields[1].value.message = "";
          f.append("open_at", workTime.value.fields[0].value.value);
          f.append("close_at", workTime.value.fields[1].value.value);
          // authService.value.transmit('seller/base/worktime' + '/' + workTime.value.id, f, successfulOp, failedOp)
          break;
        case "sendCost":
          // activateModel('sendCost')
          currentForm.value = "sendcost";
          if (typeof sendCost.fields[0].value.value.id !== "undefined")
            f.append("distance_id", sendCost.fields[0].value.value.id);
          else f.append("distance_id", sendCost.fields[0].value.value.value);
          f.append("cost", sendCost.fields[1].value.value);
          authService.value.transmit(
            "seller/base/sendcost",
            f,
            successfulOp,
            failedOp
          );
          break;
        case "serviceRange":
          // activateModel('serviceRange')
          currentForm.value = "servicerange";
          if (serviceRange.value.fields[0].value.value) {
            authService.value.transmit(
              "seller/base/servicerange/" +
                serviceRange.value.fields[0].value.value.value,
              {},
              successfulOp,
              failedOp
            );
          }
          break;
        case "shopAddress":
          // activateModel("shopAddress");
          // f.append('value',serviceRange)
          // authService.value.transmit('seller/base/servicerange',f,successfulOp,failedOp)
          break;
        case "logoImage":
          // activateModel("logoImage");
          authService.value.transmit(
            "seller/base/image",
            fData.value,
            successfulOp,
            failedOp
          );
          break;
        case "descs":
          // activateModel("descs");

          if (descs.value.fields[1].value.value) {
            f.append("specification", descs.value.fields[1].value.value);
          } else {
            f.append("specification", "");
          }

          f.append("desc", descs.value.fields[0].value.value);
          authService.value.transmit(
            "seller/register/adddesc",
            f,
            successfulOp,
            failedOp
          );
        case "شماره کارت":
          break;
        default:
          break;
      }
    };

    const setAddressFunction = (address) => {
      shopAddress.value.fields[0].value = address.name;
      let f = new FormData();
      f.append("long", address.long);
      f.append("lat", address.lat);
      f.append("address", my_address.value);
      f.append("district_id", district_id.value);
      authService.value.transmit(
        "seller/address",
        f,
        (s, d) => {
          if (s == 200) {
            hasAddress.value = true;
            $("#addressModal").modal("toggle");
          }
          successfulOp(s, d);
        },
        failedOp
      );
    };

    const getFinancials = () => {
      authService.value.receive(
        "seller/base/account",
        {},
        (s, d) => {
          if (s == 200 && d.data.length) {
            accounts.value = d.data[d.data.length - 1];
            console.log(accounts.value);
          }
        },
        (s, e) => {
          if (!s) global.alertToggle("عملیات ناموفق");
        }
      );
    };

    const submitFinancials = () => {
      let f = new FormData();
      f.append("bank_id", accounts.value.bank_id);
      f.append("account", accounts.value.account);
      f.append("sheba", accounts.value.sheba);
      f.append("card", accounts.value.card);
      if (accounts.value.id) {
        authService.value.transmit(
          "seller/base/account/" + accounts.value.id,
          f,
          (s, d) => {
            if (s == 200) global.alertToggle("اطلاعات با موفقیت افزوده شد!");
          },
          (s, e) => {
            if (!s) global.alertToggle("عملیات ناموفق");
          }
        );
        console.log(accounts.value.id);
      } else {
        authService.value.transmit(
          "seller/base/account",
          f,
          (s, d) => {
            if (s == 200) global.alertToggle("اطلاعات با موفقیت افزوده شد!");
          },
          (s, e) => {
            if (!s) global.alertToggle("عملیات ناموفق");
          }
        );
      }
    };

    const bankTabHandler = (id) => {
      if (id == 1) {
        document.getElementById("bankTab1").classList.add("bank-tab-active");
        document.getElementById("bankTab2").classList.remove("bank-tab-active");
        editBankAccount.value = false;
      } else {
        document.getElementById("bankTab2").classList.add("bank-tab-active");
        document.getElementById("bankTab1").classList.remove("bank-tab-active");
        editBankAccount.value = true;
      }
    };

    const getImage = (e, k) => {
      switch (k) {
        case 1:
          logoImage.value.logo = e.target.files[0];
          theImage.value.logo = URL.createObjectURL(e.target.files[0]);
          fData.value.append("logo", logoImage.value.logo);
          break;
        case 2:
          logoImage.value.banner = e.target.files[0];
          theImage.value.banner = URL.createObjectURL(e.target.files[0]);
          fData.value.append("banner", logoImage.value.banner);
          break;
        default:
          break;
      }
    };

    const submitWorkDaysAndHours = () => {
      for (let day = 0; day < 7; day++) {
        let form_data = new FormData();
        form_data.append("open_at", workTimes.value[day].open_at);
        form_data.append("close_at", workTimes.value[day].close_at);
        authService.value.transmit(
          "seller/base/worktime/" + workTimes.value[day].id,
          form_data,
          (s, d) => {
            if (s == 200) global.alertToggle("اطلاعات با موفقیت افزوده شد!");
          },
          (s, e) => {
            if (!s) global.alertToggle("عملیات ناموفق");
          }
        );
      }
    };

    const submitPosting = () => {
      sendCosts.value.forEach((element) => {
        let f = new FormData();
        f.append("distance_id", element.id);
        f.append("cost", parseInt(element.cost));
        authService.value.transmit(
          "seller/base/sendcost",
          f,
          (s, d) => {
            if (s == 200) global.alertToggle("اطلاعات با موفقیت افزوده شد!");
          },
          (s, e) => {
            if (!s) global.alertToggle("عملیات ناموفق");
          }
        );
      });
    };

    const props = { initial: null };
    const mapOptions = ref({
      zoom: 13,
      center: props.initial
        ? latLng(props.initial.lat, props.initial.long)
        : latLng(35.76, 51.433611),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      golpino: latLng(35.76, 51.433611),
      currentZoom: 11.5,
      currentCenter: latLng(35.76, 51.433611),
      showParagraph: true,
      mapOptions: {
        zoomSnap: 0.5,
      },
      showMap: true,
    });

    const zoomUpdate = (zoom) => {
      mapOptions.value.currentZoom = zoom;
    };
    const address = ref({ lat: 0, lng: 0 });
    const tab_items = ref(["عمومی", "مالی", "شرایط ارسال", "ساعات کاری"]);
    const my_tab = ref(null);
    const address_error = ref(null);
    const district_id = ref(null);
    const my_address = ref(null);
    const theCenter = ref(null);
    const provinces = ref(["گیلان", "اصفهان", "مشهد", "تهران"]);
    const updateCenter = function (center) {
      this.$refs.map.mapObject.invalidateSize();
      theCenter.value = latLng(center.lat, center.lng);
      console.log("this is center");
      console.log(theCenter.value.lat);
      console.log(theCenter.value.lng);
    };
    const change = function () {
      latLng(theCenter.value.lat, theCenter.value.lng);
      address_data.value.lat = theCenter.value.lat;
      address_data.value.long = theCenter.value.lng;
      this.choose_location = true;
      this.choose_location = false;
      this.choose_location = true;
    };
    const submit_sending = () => {
      let form_data = new FormData();
      if (ready_time.value) {
        form_data.append("time", ready_time.value);
        authService.value.transmit(
          "seller/base/prepare",
          form_data,
          (s, d) => {
            global.alertToggle("عملیات موفق زمان آماده سازی");
          },
          (s, e) => {
            if (e) global.alertToggle(" اشکال در ثبت زمان آماده سازی");
          }
        );
      }

      if (my_service_range.value) {
        authService.value.transmit(
          "seller/base/servicerange/" + my_service_range.value,
          {},
          (s, d) => {
            console.log(s);
          },
          (s, e) => {
            if (e) console.log("اشکال در ثبت محدوده خدمت رسانی");
          }
        );
      }

      if (my_service_range.value) {
        sendCosts.value.forEach((element, index) => {
          let my_form_data = new FormData();
          my_form_data.append("distance_id", element.id);
          my_form_data.append("cost", element.cost);
          authService.value.transmit(
            "seller/base/sendcost",
            my_form_data,
            (s, d) => {
              active_alarm.value = false;
            },
            (s, e) => {
              if (e) console.log("اشکال در ثبت هزینه ارسال");
            }
          );
        });
        // for (let hello = 0; hello < 8; hello++) {}
      } else {
        active_alarm.value = true;
      }
    };
    const submit_address = () => {
      if (
        address_data.value.lat &&
        address_data.value.long &&
        my_address.value &&
        district_id.value
      ) {
        let f = new FormData();
        f.append("long", address_data.value.long);
        f.append("lat", address_data.value.lat);
        f.append("address", my_address.value);
        f.append("district_id", district_id.value);
        authService.value.transmit("seller/address", f, (s, d) => {
          if (s == 200) {
            hasAddress.value = true;
            $("#addressModal").modal("toggle");
            global.alertToggle("آدرس با موفقیت افزوده شد!");
          }
        });
      } else if (!address_data.value.lat || !address_data.value.long) {
        address_error.value =
          "لطفا بعد از مشخص کردن آدرس روی نقشه، کلید انتخاب موقعیت را کلیک کنید";
      } else if (!my_address.value || !district_id.value) {
        address_error.value = "* لطفا منطقه و متن آدرس را کامل کنید";
      }
    };
    return {
      get_distances,
      my_address,
      district_id,
      address_error,
      submit_address,
      ready_time,
      active_alarm,
      my_service_range,
      submit_sending,
      change,
      theCenter,
      updateCenter,
      address_data,
      base_data,
      provinces,
      global,
      baseInfoLoaded,
      districts,
      authService,
      sellerServiceDistricts,
      address,
      zoomUpdate,
      mapOptions,
      workTimesIds,
      sendCosts,
      submitPosting,
      workTimes,
      submitWorkDaysAndHours,
      descs,
      hasAddress,
      sellerSendCosts,
      days,
      getImage,
      theImage,
      logoImage,
      setAddressFunction,
      shopAddress,
      serviceRange,
      serviceRanges,
      sendCost,
      distances,
      preparationTime,
      workTime,
      bankNames,
      editBankAccount,
      bankTabHandler,
      aBankAccount,
      bankToEdit,
      accounts,
      submitFinancials,
      submitValue,
      menuItems,
      basicModels,
      secondaryModels,
      notifModels,
      newsModels,
      tab_items,
      my_tab,
      shop_address,
      distance_costs,
    };
  },
  data: () => ({
    active_alarm: false,
    select_district: null,
    my_logo_chosen_url: null,
    my_banner_chosen_url: null,
    my_logo_chosen: null,
    my_banner_chosen: null,
    mainImage: null,
    shopDistricts: [],
    selectedExtraDistrict: { value: null, valid: true },
    newServiceDistrict: null,
    serviceDistricts: null,
    message: null,
    theDistrict: null,
    choose_location: false,
    theAddress: {
      name: { value: null, valid: true },
      district_id: { id: null, value: null, valid: true },
      lat: null,
      long: null,
      address: { value: null, valid: true },
    },
    marker: true,
    setAddress: false,
    workDays: [],
    changedPPTime: null,
    my_width: null,
    isMobile: false,
    isDesktop: true,
  }),
  methods: {
    submit_public() {
      let form_data = new FormData();
      if (this.my_logo_chosen || this.my_banner_chosen) {
        if (this.my_logo_chosen) {
          form_data.append("logo", this.my_logo_chosen);
        }
        if (this.my_banner_chosen) {
          form_data.append("banner", this.my_banner_chosen);
        }
        this.authService.transmit(
          "seller/base/image",
          form_data,
          (s, d) => {
            global.alertToggle("اطلاعات با موفقیت افزوده شد!");
          },
          (s, e) => {
            if (e) console.log("عملیات ناموفق");
          }
        );
      }
    },
    up_image(fuck) {
      switch (fuck) {
        case 1:
          this.my_logo_chosen_url = URL.createObjectURL(
            this.$refs.logo.files[0]
          );
          this.my_logo_chosen = this.$refs.logo.files[0];
          break;
        case 2:
          this.my_banner_chosen_url = URL.createObjectURL(
            this.$refs.banner.files[0]
          );
          this.my_banner_chosen = this.$refs.banner.files[0];
          break;
      }
    },
    banner_up() {},
    logo_up() {},
    close_district(district, index) {
      this.shopDistricts.splice(index, 1);

      this.authService.remove(
        "seller/base/district/" + district.id,
        {},
        (s, d) => {
          if (s == 200) {
          }
        },
        (s, e) => {
          alert("درخواست دچار خطا شد");
        }
      );
    },
    handleResize() {
      this.my_width = window.innerWidth;
      if (this.my_width > 700) {
        this.isMobile = false;
        this.isDesktop = true;
      } else {
        this.isMobile = true;
        this.isDesktop = false;
      }
    },
    addExtraDistrict: function () {
      let f = new FormData();
      console.log(this.select_district.id);
      f.append("district_id[0]", this.select_district.id);
      this.authService.transmit(
        "seller/base/district",
        f,
        (s, d) => {
          if (s == 200) {
            this.getAllDistrictsOfShop();
          }
        },
        (s, e) => {
          alert("درخواست دچار خطا شد");
        }
      );
    },
    deleteExtraDistrict: function () {
      let target = "";
      this.shopDistricts.map((x) => {
        if (x.district_id == this.selectedExtraDistrict.value.id) {
          target = x.id;
        }
      });
      this.authService.remove(
        "seller/base/district/" + target,
        {},
        (s, d) => {
          if (s == 200) {
            global.alertToggle("اطلاعات با موفقیت افزوده شد!");
            this.getAllDistrictsOfShop();
          }
        },
        (s, e) => {
          alert("درخواست دچار خطا شد");
        }
      );
    },
    selectExtraDistrict: function (d) {
      this.selectedExtraDistrict.text = d.name;
      this.selectedExtraDistrict.value = d;
    },
    getAllDistrictsOfShop() {
      this.authService.receive(
        "seller/base/district",
        {},
        (s, d) => {
          if (s == 200) this.shopDistricts = d.data;
        },
        (s, e) => {
          alert("درخواست دچار خطا شد");
        }
      );
    },
    send: function () {
      this.message = null;
      this.theAddress.address.valid = true;
      this.theAddress.address.message = "";
      this.theAddress.name.valid = true;
      this.theAddress.name.message = "";
      if (this.theAddress.lat == null) {
        this.message =
          "لطفا ابتدا موقعیت مورد نظر را یافته و سپس بر روی دکمه ی انتخاب موقعیت کلیک کنید!";
      }
      if (
        this.theAddress.address.value == null ||
        this.theAddress.address.value == ""
      ) {
        this.theAddress.address.valid = false;
        this.theAddress.address.message = "لطفا متن آدرس را وارد کنید";
      }
      if (this.theDistrict == null || !this.theDistrict.id) {
        this.theAddress.name.valid = false;
        this.theAddress.name.message = "وارد کردن محله الزامی است";
      } else if (
        this.theAddress.lat != null &&
        (this.theAddress.name.value != null ||
          this.theAddress.name.value != "") &&
        (this.theAddress.address.value != null ||
          this.theAddress.address.value != "")
      ) {
        this.theAddress.district_id = this.theDistrict.id;
        // this.$emit('addressComplete', this.theAddress)
        this.setAddressFunction(this.theAddress);
        this.theAddress = {
          name: { value: null, valid: true },
          district_id: { id: null, value: null, valid: true },
          lat: null,
          long: null,
          address: { value: null, valid: true },
        };
        this.theDistrict = null;
      }
    },
    selectDistrict: function (d) {
      this.theDistrict = d;
    },

    submit() {
      // this.submitWorkDaysAndHours();
      // this.submitValue('workTime');
      // this.submitValue('ppTime');
      // this.submitValue('sendCost');
      // this.submitValue('serviceRange');
    },
    submitGeneral() {
      this.submitValue("descs");
      this.submitValue("logoImage");
      // this.submitValue('shopAddress');
      this.submitValue("serviceRange");
    },
    submitPostingGroup() {
      this.submitPosting();
    },
    submitPptTime() {
      this.submitValue("ppTime");
    },
    changeServiceRange() {
      console.log($("#saturday").val());
    },
    setWorkDay() {
      // workTime.value.fields[0].value.value = sellerWorkTime.value[n.value.value - 1].open_at
      // workTime.value.fields[1].value.value = sellerWorkTime.value[n.value.value - 1].close_at
      // workTime.value.id = sellerWorkTime.value[n.value.value - 1].id
    },
    addServiceDistrict() {
      let f = new FormData();

      var selectedDistrict;
      this.districts.map((d) => {
        if (this.newServiceDistrict === d.name) {
          selectedDistrict = d.id;
        }
      });
      f.append("district_id[" + 0 + "]", selectedDistrict);
      this.authService.transmit(
        "seller/base/district",
        f,
        (s, d) => {
          if (s == 200) global.alertToggle("اطلاعات با موفقیت افزوده شد!");
          this.authService.receive(
            "seller/base/district",
            {},
            (s, d) => {
              if (s == 200) {
                this.serviceDistricts = d.data;
              }
            },
            (s, e) => {}
          );
        },
        (s, e) => {
          if (!s) alert("عملیات ناموفق");
        }
      );
    },
    deleteServiceDistrict(deleteId) {
      this.authService.remove(
        "seller/base/district/" + deleteId,
        {},
        (s, d) => {
          if (s == 200) {
            this.serviceDistricts.map((s) => {
              if (s.id === deleteId) {
                this.serviceDistricts.remove(s);
              }
            });
          }
        },
        (s, e) => {}
      );
    },
  },

  // created() {
  //   this.activateModel("workTime");
  //   this.activateModel("sendCost");
  // },
  mounted() {
    window.addEventListener("resize", this.handleResize());
    this.handleResize();

    this.authService.receive(
      "search/district",
      {},
      (s, d) => {
        if (s == 200) {
          this.districts = d.data;
          this.districts.map((di) => {
            di.text = di.name;
          });
          this.getAllDistrictsOfShop();

          this.districts.map((dd) => {
            this.theDistrict = {};
            this.theDistrict.text = dd.name;
            this.theDistrict.value = dd.id;
            this.theDistrict.name = dd.name;
            this.theDistrict.id = dd.id;
          });
        }
      },
      (s, e) => {}
    );

    this.authService.receive(
      "seller/base/district",
      {},
      (s, d) => {
        if (s == 200) {
          this.serviceDistricts = d.data;
        }
      },
      (s, e) => {}
    );
    setTimeout(() => {
      if (this.$refs.map) this.$refs.map.mapObject.invalidateSize();
    }, 4000);
  },
};
</script>
<style lang="scss">
.settings {
  font-size: 0.85rem;
  .v-autocomplete__content .v-list__tile {
    height: 100px;
  }
  .v-tab {
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.0892857143em;
    line-height: normal;
    min-width: 86px;
    padding: 16px 5px;
    display: block;
    flex: auto;
    justify-content: unset;
  }
}
.mobile {
  .settings {
    font-size: 13px;
    min-width: 70px;
    padding: 0 3px;
    .v-tab {
      font-size: 12px;
      min-width: 40px;
    }
  }
  .img-wrapper {
    width: 100%;

    img {
      width: 100%;
    }
  }
  .image-button {
    margin: 5px 0;
    width: 45%;
  }
  .my-button {
    &.large {
      width: 100%;
    }
  }
}
.image-button {
  color: #eb307b;
  border: solid 1px #eb307b;
  width: 260px;
  padding: 10px;
  display: inline-block;
  margin: 5px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  &.has-image {
    width: 100%;
    margin: 5px 0;
    &.logo {
      img {
        max-height: 120px;
        width: 40%;
      }
    }
    &:hover {
      box-shadow: 1px 1px 3px #eb307b;
      background: white;
      color: #eb307b;
    }
  }
  &:focus {
    outline: none;
  }
  &:hover {
    background: #eb307b;
    color: white;
  }
  img {
    max-height: 270px;
    border-radius: 10px;
    width: 100%;
  }
}
.select-facade2 {
  border: 1px solid rgba(127, 127, 127, 0.4);
  border-radius: 5px;
  padding: 4px 10px 4px 10px;
  position: relative;
  min-width: 80px;
  font-weight: lighter;
  background-color: rgba(0, 0, 0, 0.06) !important;
}

.general-settings {
  width: 100%;
}

.dropdown {
  direction: ltr !important;
}

.btn-secondary {
  color: #6c757d;
  background-color: #fff;
  border-color: #6c757d;
}

.active {
  color: #682ad5 !important;
}

.tabBtn {
  width: 25%;
  margin-right: 5%;
  color: gray;
  border: 2px solid;
  border-radius: 10px;
  height: 30px;
}

.tabBtn:hover {
  color: #682ad5 !important;
}

.section-divider {
  background-color: #e8e8e8;
  border-radius: 4px;
  padding: 0.2rem 1rem 0.2rem 1rem;
}

.section-divider p {
  margin: 0px;
}

.deactive {
  background: none !important;
  border: none !important;
  color: #000 !important;
  font-weight: normal !important;
}

.right-bar {
  border-left: 1px solid rgba(127, 127, 127, 0.3);
  display: inline-block;
  margin: 0px;
}

.mid-right {
  border-top: 1px solid rgba(127, 127, 127, 0.3);
  border-bottom: 1px solid rgba(127, 127, 127, 0.3);
}

.main-section {
  width: 100%;
  display: inline-block;
  margin: 0px;
  min-height: 100vh;
}

.bank-form {
  padding: 10px;
  max-width: 500px;
  margin: 0 auto;
}

.bank-tab-active {
  background-color: rgba(127, 127, 127, 0.1);
}

.bank-tab {
  text-align: center;
  padding: 1rem 1rem 0px 1rem;
}

#bankTab1 {
  border-top-left-radius: 20px;
}

#bankTab2 {
  border-top-right-radius: 20px;
}

.bank-tab:hover {
  cursor: pointer;
}

.seller-logo-locker img {
  width: 50%;
}

.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  align-items: stretch;
  min-height: 0px !important;
}
.settings {
  .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
    display: flex;
    flex: 1 1 auto;
    position: relative;
    height: 40px;
  }
}

.workDayRow {
  height: 50px;
}

.workDayCheckBox {
  margin-top: 20%;
}

.workDayText {
  margin-top: 10%;
}

table {
  border-collapse: collapse;
  border: none;
}

th,
td {
  border: 1px solid black;
  padding: 4px 16px;
  font-family: Times New Roman;
  font-size: 24px;
  text-align: left;
}

th {
  background-color: #c8c8c8;
  cursor: pointer;
}

.leaflet-container {
  overflow: auto !important;
  height: 450px;
  width: 100%;
}
.map-container {
}
#addressMap {
  height: 300px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  z-index: 8;
  border-radius: 10px;
  overflow: hidden;
}

#addressMap .map-marker {
  position: absolute;
  z-index: 1111 !important;
  top: 125px;
  right: 50%;
}

.address-modal-header {
  padding: 0.5rem 2rem 0.5rem 2rem;
  border-bottom: 1px solid rgba(179, 179, 179, 0.3);
}
.distance-text {
  margin-bottom: 26px;
}
.map-control {
  position: absolute;
  z-index: 1111 !important;
  bottom: 5%;
  left: 5%;
  background: #ff58c2;
  padding: 10px;
  border-radius: 20px;
  color: white;
  &:focus {
    outline: none;
  }
}

.modal-dialog {
  max-width: 700px !important;
}

.invalid {
  color: red;
  margin-top: 1rem;
  text-align: center;
  width: 100%;
}

.gray {
  background-color: rgba(0, 0, 0, 0.06) !important;
}
.head-slider {
  .theme--light.v-toolbar.v-sheet {
    background: #ffd5e9;
  }
  .v-tab {
    letter-spacing: normal;
    color: #eb307b;
  }
}
.showcase-locker {
  img {
    border-radius: 10px;
  }
}
.big-upload {
  text-align: center;
  border: 2px dashed #eb307b;
  font-size: 2.5vw;
  border-radius: 10px;
  width: 90%;
  margin: 0 auto;
}
.line {
  border-bottom: solid 1px #eb307b;
  border-top: solid 1px #eb307b;
  &.bottom {
    border-top: none;
  }
}
.upload-locker {
  img {
    width: 70px;
  }
}
.tag-location {
  background: #e2e1e1;
}
.my-button {
  &.large {
    width: 50%;
  }
}
.setting-container {
  max-width: 550px;
  margin: 0 auto;
}
.v-tabs:not(.v-tabs--vertical).v-tabs--right
  > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes)
  .v-slide-group__next,
.v-tabs:not(.v-tabs--vertical):not(.v-tabs--right)
  > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes)
  .v-slide-group__prev {
  display: none;
}

.settings {
  .v-tabs--align-with-title
    > .v-tabs-bar:not(.v-tabs-bar--show-arrows):not(.v-slide-group--is-overflowing)
    > .v-slide-group__wrapper
    > .v-tabs-bar__content
    > .v-tabs-slider-wrapper
    + .v-tab {
    margin-right: 0;
  }
  .leaflet-container {
    overflow: hidden !important;
  }
}
</style>